// frontend/src/components/common/ToggleSwitch.jsx
import React from 'react';

export default function ToggleSwitch({ checked, onChange, label, disabled = false }) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        opacity: disabled ? 0.6 : 1,
        position: 'relative'
      }}
    >
      {/* Native checkbox overlay covering the entire control for reliable interaction */}
      <input
        type="checkbox"
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(e) => !disabled && onChange && onChange(e.target.checked)}
        style={{
          position: 'absolute',
          opacity: 0,
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          zIndex: 2,
          margin: 0
        }}
      />

      {/* Switch Track */}
      <div
        style={{
          width: '36px',
          height: '20px',
          backgroundColor: checked ? '#2563eb' : '#cbd5e1',
          borderRadius: '20px',
          position: 'relative',
          transition: 'background-color 0.2s ease',
          display: 'inline-flex',
          alignItems: 'center',
          padding: '2px',
          flexShrink: 0,
          zIndex: 1
        }}
      >
        {/* Switch Thumb */}
        <div
          style={{
            width: '16px',
            height: '16px',
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            transform: checked ? 'translateX(16px)' : 'translateX(0px)',
            transition: 'transform 0.2s ease',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
          }}
        />
      </div>

      {label && (
        <span style={{ fontWeight: 500, color: '#334155', fontSize: '13px' }}>
          {label}
        </span>
      )}
    </label>
  );
}
